import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const Wrapper = styled(Stack)``;
